import { gql } from "@apollo/client";

export const GET_TROUBLESHOOT_BY_DATE_AND_VM_ID = gql`
  query GetTroubleshootByDateAndVmId($date: String!, $vmId: Int!) {
    getTroubleshootByDateAndVmId(date: $date, vmId: $vmId) {
      id
      vmId
      summary
      severity
      action
      createdAt
      stoppedAt
      components {
        spring_boot {
          status
          details
          suggestion
        }
        syslog {
          status
          details
          suggestion
        }
        pm2 {
          status
          details
          suggestion
        }
        nginx {
          status
          details
          suggestion
        }
        postgresql {
          status
          details
          suggestion
        }
        system {
          uptime
          memory
          disk
          cpu
          network
          status
          details
          suggestion
        }
      }
    }
  }
`;